export default function Hero() {
  const handleScroll = (target: string) => {
    const el = document.querySelector(target);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center pt-16 bg-background-50 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-primary-100/40 via-background-50 to-accent-100/30"></div>

      <div className="relative w-full max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-5 whitespace-nowrap">
              <i className="ri-fire-line text-sm"></i>
              全网热播 · 高清秒开
            </span>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-5xl leading-tight text-foreground-950 mb-3">
              香蕉影视 - 电视剧全集免费高清在线追剧平台
            </h1>

            <p className="text-lg md:text-xl text-primary-500 font-heading mb-6">
              不缓冲流畅秒开，全集免费看，追剧必备
            </p>

            <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              香蕉影视汇聚全网最新热播电视剧资源，涵盖国产剧、韩剧、美剧、日剧等多元品类，
              每日同步更新最新剧集，支持1080P超清画质播放。无论您是在通勤路上还是宅家休息，
              打开香蕉影视即可畅享极速追剧体验——无需注册登录，不花一分钱，全集免费看，
              真正实现「打开就能看，点开就播放」的无障碍追剧方式。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-foreground-900">20000+</div>
                <div className="text-xs text-foreground-500 mt-1">海量剧集资源</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-foreground-900">1080P</div>
                <div className="text-xs text-foreground-500 mt-1">超清画质体验</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-foreground-900">7×24</div>
                <div className="text-xs text-foreground-500 mt-1">全天候内容更新</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                onClick={(e) => { e.preventDefault(); handleScroll('#ranking'); }}
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-white font-medium rounded-lg hover:bg-primary-600 transition-colors text-center whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-play-circle-line mr-2"></i>
                开始追剧
              </a>
              <a
                href="#app"
                onClick={(e) => { e.preventDefault(); handleScroll('#app'); }}
                className="w-full sm:w-auto px-8 py-3 border border-primary-300 text-primary-600 font-medium rounded-lg hover:bg-primary-50 transition-colors text-center whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-download-2-line mr-2"></i>
                下载APP
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-md lg:max-w-lg aspect-[4/3] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20cinematic%20abstract%20composition%20with%20warm%20coral%20and%20amber%20gradient%20tones%2C%20soft%20atmospheric%20lighting%20creating%20depth%20and%20dimension%2C%20subtle%20film%20reel%20and%20screen%20like%20geometric%20elements%2C%20dark%20rich%20shadows%20contrasting%20with%20warm%20highlights%2C%20clean%20minimalist%20aesthetic%20with%20professional%20photography%20quality%2C%20sophisticated%20entertainment%20industry%20visual%2C%20elegant%20and%20contemporary%20design%20suitable%20for%20streaming%20platform%20hero%20section%2C%20no%20text%20or%20logos%20visible&width=900&height=675&seq=hero-main-2026&orientation=landscape"
                alt="香蕉影视 - 高清在线追剧平台"
                className="w-full h-full object-cover object-top"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                  if (target.parentElement) target.parentElement.style.display = 'none';
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}